module.exports = __webpack_public_path__ + "img/logo-intl-white.e869c00.webp";